import BUTAN_YM1A from '@/statics/devices/Node7/AC/BUTAN_YM1A.js'
import GENERAL_COOL_HEAT_ZH_JT_03 from '@/statics/devices/Node7/AC/GENERAL_COOL_HEAT_ZH_JT_03.js'
import GENERAL_COOL_HEAT_ZH_LW_01 from '@/statics/devices/Node7/AC/GENERAL_COOL_HEAT_ZH_LW_01.js'
import GPLUS from '@/statics/devices/Node7/AC/GPLUS.js'
import GREE from '@/statics/devices/Node7/AC/GREE.js'
import HAIER_YR_HD06 from '@/statics/devices/Node7/AC/HAIER_YR_HD06.js'
import hisense from '@/statics/devices/Node7/AC/hisense.js'
import HITACHI_RAR2P2 from '@/statics/devices/Node7/AC/HITACHI_RAR2P2.js'
import HYUNDAI_ESAF_09HN1 from '@/statics/devices/Node7/AC/HYUNDAI_ESAF_09HN1.js'
import LG_6711A90031Y from '@/statics/devices/Node7/AC/LG_6711A90031Y.js'
import LG_LS_H2766PG from '@/statics/devices/Node7/AC/LG_LS_H2766PG.js'
import LG_YKR_H_209E from '@/statics/devices/Node7/AC/LG_YKR_H_209E.js'
import MITSUBISHI_SG10A from '@/statics/devices/Node7/AC/MITSUBISHI_SG10A.js'
import NONAME_R51D_E from '@/statics/devices/Node7/AC/NONAME_R51D_E.js'
import OGENERAL_AR_JW2 from '@/statics/devices/Node7/AC/OGENERAL_AR_JW2.js'
import OGENERAL_AR_RAJ1E from '@/statics/devices/Node7/AC/OGENERAL_AR_RAJ1E.js'
import PANASONIC_A75C3712 from '@/statics/devices/Node7/AC/PANASONIC_A75C3712.js'
import PASARGADELECTRIC from '@/statics/devices/Node7/AC/PASARGADELECTRIC.js'
import PLASMA_STREAM_YKR_K_002E from '@/statics/devices/Node7/AC/PLASMA_STREAM_YKR_K_002E.js'
import RYOKO from '@/statics/devices/Node7/AC/RYOKO.js'
import SAMSUNG_AR19MRFHPWKN from '@/statics/devices/Node7/AC/SAMSUNG_AR19MRFHPWKN.js'
import SHARP_CRMC_A780JBEZ from '@/statics/devices/Node7/AC/SHARP_CRMC_A780JBEZ.js'
import SHARP_NN from '@/statics/devices/Node7/AC/SHARP_NN.js'
import SHARP_YACIFBI from '@/statics/devices/Node7/AC/SHARP_YACIFBI.js'
import SHARP_YB1FA from '@/statics/devices/Node7/AC/SHARP_YB1FA.js'
import TRUST_RG36A11 from '@/statics/devices/Node7/AC/TRUST_RG36A11.js'
import audioP12 from '@/statics/devices/Node7/TV/audioP12.js'
import EPSON_E8_U42 from '@/statics/devices/Node7/TV/EPSON_E8_U42.js'
import jvc_RM_C1100 from '@/statics/devices/Node7/TV/jvc_RM_C1100.js'
import jvc_RM_C1251G from '@/statics/devices/Node7/TV/jvc_RM_C1251G.js'
import lg_6710CDAL01G from '@/statics/devices/Node7/TV/lg_6710CDAL01G.js'
import lg_6710V00067G from '@/statics/devices/Node7/TV/lg_6710V00067G.js'
import lg_6711R1P070B_DVD from '@/statics/devices/Node7/TV/lg_6711R1P070B_DVD.js'
import lg_6711R1P070B_TV from '@/statics/devices/Node7/TV/lg_6711R1P070B_TV.js'
import lg_6711R1P072B_DVD from '@/statics/devices/Node7/TV/lg_6711R1P072B_DVD.js'
import lg_6711R1P072B_TV from '@/statics/devices/Node7/TV/lg_6711R1P072B_TV.js'
import lg_6711R1P072B_VCR from '@/statics/devices/Node7/TV/lg_6711R1P072B_VCR.js'
import lg_AKB32273504 from '@/statics/devices/Node7/TV/lg_AKB32273504.js'
import LG_AKB74475403 from '@/statics/devices/Node7/TV/LG_AKB74475403.js'
import lg_EC970W from '@/statics/devices/Node7/TV/lg_EC970W.js'
import lg_MKJ32022805_DVD from '@/statics/devices/Node7/TV/lg_MKJ32022805_DVD.js'
import lg_MKJ32022805_VCR from '@/statics/devices/Node7/TV/lg_MKJ32022805_VCR.js'
import marantz_RC027SR from '@/statics/devices/Node7/TV/marantz_RC027SR.js'
import Mediastar_NN from '@/statics/devices/Node7/TV/Mediastar_NN.js'
import mediastar_receiver from '@/statics/devices/Node7/TV/mediastar_receiver.js'
import media_x801 from '@/statics/devices/Node7/TV/media_x801.js'
import NEC_TV from '@/statics/devices/Node7/TV/NEC_TV.js'
import oppo_nn from '@/statics/devices/Node7/TV/oppo_nn.js'
import panasonic_EUR7628010_DVD from '@/statics/devices/Node7/TV/panasonic_EUR7628010_DVD.js'
import panasonic_EUR7628010_TV from '@/statics/devices/Node7/TV/panasonic_EUR7628010_TV.js'
import panasonic_EUR7628010_VCR from '@/statics/devices/Node7/TV/panasonic_EUR7628010_VCR.js'
import panasonic_N2QADC000006 from '@/statics/devices/Node7/TV/panasonic_N2QADC000006.js'
import panasonic_N2QAYB000010 from '@/statics/devices/Node7/TV/panasonic_N2QAYB000010.js'
import panasonic_N2QAYB000239 from '@/statics/devices/Node7/TV/panasonic_N2QAYB000239.js'
import panasonic_theater_system from '@/statics/devices/Node7/TV/panasonic_theater_system.js'
import samsung_AA59_00370A from '@/statics/devices/Node7/TV/samsung_AA59_00370A.js'
import samsung_AA59_00382A from '@/statics/devices/Node7/TV/samsung_AA59_00382A.js'
import samsung_AA59_00489A from '@/statics/devices/Node7/TV/samsung_AA59_00489A.js'
import samsung_AA59_00600A from '@/statics/devices/Node7/TV/samsung_AA59_00600A.js'
import samsung_AA59_00638A from '@/statics/devices/Node7/TV/samsung_AA59_00638A.js'
import samsung_AA64_50236A from '@/statics/devices/Node7/TV/samsung_AA64_50236A.js'
import samsung_BN59_00507A from '@/statics/devices/Node7/TV/samsung_BN59_00507A.js'
import samsung_BN59_00516A_TV from '@/statics/devices/Node7/TV/samsung_BN59_00516A_TV.js'
import samsung_BN59_00603A from '@/statics/devices/Node7/TV/samsung_BN59_00603A.js'
import samsung_BN59_00861A from '@/statics/devices/Node7/TV/samsung_BN59_00861A.js'
import samsung_BN59_00865A from '@/statics/devices/Node7/TV/samsung_BN59_00865A.js'
import samsung_BN59_00940A from '@/statics/devices/Node7/TV/samsung_BN59_00940A.js'
import samsung_BN59_01178F from '@/statics/devices/Node7/TV/samsung_BN59_01178F.js'
import samsung_MF59_00242C from '@/statics/devices/Node7/TV/samsung_MF59_00242C.js'
import sharp_GA339WJSA from '@/statics/devices/Node7/TV/sharp_GA339WJSA.js'
import sharp_RRMCG0101AJSA from '@/statics/devices/Node7/TV/sharp_RRMCG0101AJSA.js'
import showbox_nn from '@/statics/devices/Node7/TV/showbox_nn.js'
import sony_projector_RM_PJ28 from '@/statics/devices/Node7/TV/sony_projector_RM_PJ28.js'
import sony_RM_ED009 from '@/statics/devices/Node7/TV/sony_RM_ED009.js'
import sony_TV_12D1 from '@/statics/devices/Node7/TV/sony_TV_12D1.js'
import sony_V164G_TV from '@/statics/devices/Node7/TV/sony_V164G_TV.js'
import starmax_nn from '@/statics/devices/Node7/TV/starmax_nn.js'
import XVISION_FMI4 from '@/statics/devices/Node7/TV/XVISION_FMI4.js'
import XVISION_KONKA_D2 from '@/statics/devices/Node7/TV/XVISION_KONKA_D2.js'
import xvision_type3 from '@/statics/devices/Node7/TV/xvision_type3.js'


const NODE7 = {
  NAME: 'IR-DHT11',
  INPUT1: {
    NAME: 'NODE7_INPUT1_NAME',
    TYPE: 'temperatureSensor',
    ICON: 'temperature',
    PARAMETER_ID: 0x8120,
  },
  INPUT2: {
    NAME: 'NODE7_INPUT2_NAME',
    TYPE: 'humiditySensor',
    ICON: 'humidity',
    PARAMETER_ID: 0x8121,
  },
  IR: {
    PARAMETER_ID: 0x4700,
  },
  TEMPERATURE: {
    NAME: 'NODE7_TEMPERATURE_NAME',
    TYPE: 'internalTemperature',
    ICON: 'temperature',
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
}
NODE7.DEFAULT_INSTRUCTIONS = [];

NODE7.devices = [
  {
    name: "NODE7_AC_NAME",
    icon: "airConditioner",
    brands: [
      {
        name: "Bootan",
        devices: [
          BUTAN_YM1A,
        ],
      },
      {
        name: "General",
        devices: [
          GENERAL_COOL_HEAT_ZH_LW_01,
          GENERAL_COOL_HEAT_ZH_JT_03,
        ],
      },
      {
        name: "Haier",
        devices: [
          HAIER_YR_HD06,
        ],
      },
      {
        name: "Hisense",
        devices: [
          hisense,
        ],
      },
      {
        name: "LG",
        devices: [
          LG_6711A90031Y,
          LG_YKR_H_209E,
          LG_LS_H2766PG,
        ],
      },
      {
        name: "OGeneral",
        devices: [
          OGENERAL_AR_JW2,
          OGENERAL_AR_RAJ1E
        ],
      },
      {
        name: "Panasonic",
        devices: [
          PANASONIC_A75C3712,
        ],
      },
      {
        name: "Pasargad Electric",
        devices: [
          PASARGADELECTRIC,
        ],
      },
      {
        name: "Plasma Stream",
        devices: [
          PLASMA_STREAM_YKR_K_002E,
        ],
      },
      {
        name: "SAMSUNG",
        devices: [
          SAMSUNG_AR19MRFHPWKN
        ],
      },
      {
        name: "Sharp",
        devices: [
          SHARP_CRMC_A780JBEZ,
          SHARP_NN,
          SHARP_YACIFBI,
          SHARP_YB1FA
        ],
      },
      {
        name: "Trust",
        devices: [
          TRUST_RG36A11,
        ],
      },
      {
        name: "Ukrainian",
        devices: [
          NONAME_R51D_E,
        ],
      },
      {
        name: "RYOKO",
        devices: [
          RYOKO,
        ],
      },
      {
        name: "GPLUS",
        devices: [
          GPLUS,
        ],
      },
      {
        name: "GREE",
        devices: [
          GREE,
        ],
      },
      {
        name: "HYUNDAI",
        devices: [
          HYUNDAI_ESAF_09HN1,
        ],
      },
      {
        name: "HITACHI",
        devices: [
          HITACHI_RAR2P2,
        ],
      },
      {
        name: "MITSUBISHI",
        devices: [
          MITSUBISHI_SG10A,
        ],
      },
    ],
  },
  {
    name: "NODE7_TV_NAME",
    icon: "remoteController",
    brands: [
      {
        name: "XVision",
        devices: [
          XVISION_FMI4,
          XVISION_KONKA_D2,
          xvision_type3,
        ],
      },
      {
        name: "LG",
        devices: [
          LG_AKB74475403,
          lg_6710CDAL01G,
          lg_6710V00067G,
          lg_6711R1P070B_DVD,
          lg_6711R1P070B_TV,
          lg_6711R1P072B_DVD,
          lg_6711R1P072B_TV,
          lg_6711R1P072B_VCR,
          lg_EC970W,
          lg_MKJ32022805_DVD,
          lg_MKJ32022805_VCR,
          lg_AKB32273504
        ],
      },
      {
        name: "EPSON",
        devices: [
          EPSON_E8_U42,
        ],
      },
      {
        name: "JVC",
        devices: [
          jvc_RM_C1100,
          jvc_RM_C1251G,
        ],
      },
      {
        name: "NEC",
        devices: [
          NEC_TV,
        ],
      },
      {
        name: "SAMSUNG",
        devices: [
          samsung_AA59_00370A,
          samsung_AA59_00382A,
          samsung_AA59_00489A,
          samsung_AA59_00600A,
          samsung_AA64_50236A,
          samsung_BN59_00507A,
          samsung_BN59_00516A_TV,
          samsung_BN59_00603A,
          samsung_BN59_00861A,
          samsung_BN59_00865A,
          samsung_BN59_00940A,
          samsung_MF59_00242C,
          samsung_AA59_00638A,
          samsung_BN59_01178F,
          // samsung_00008E,
        ],
      },
      {
        name: "SHARP",
        devices: [
          sharp_GA339WJSA,
          sharp_RRMCG0101AJSA,
        ],
      },
      {
        name: "SONY",
        devices: [
          sony_RM_ED009,
          sony_TV_12D1,
          sony_V164G_TV,
          sony_projector_RM_PJ28
        ],
      },
      {
        name: "PANASONIC",
        devices: [
          panasonic_EUR7628010_DVD,
          panasonic_EUR7628010_TV,
          panasonic_EUR7628010_VCR,
          panasonic_N2QADC000006,
          panasonic_N2QAYB000010,
          panasonic_N2QAYB000239,
          panasonic_theater_system,
        ],
      },
      {
        name: "MEDIA STAR",
        devices: [
          mediastar_receiver,
          Mediastar_NN,
        ],
      },
      {
        name: "MARANTZ",
        devices: [
          marantz_RC027SR,
        ],
      },
      {
        name: "MEDIA X8",
        devices: [
          media_x801,
        ],
      },
      {
        name: "OPPO",
        devices: [
          oppo_nn,
        ],
      },
      {
        name: "SHOWBOX",
        devices: [
          showbox_nn,
        ],
      },
      {
        name: "STARMAX",
        devices: [
          starmax_nn,
        ],
      },
      {
        name: "AUDIO",
        devices: [
          audioP12,
        ],
      },
      // {
      //   name: "TAHA Bluetooth Speaker",
      //   devices: [
      //     speaker_blue_taha,
      //   ],
      // },
    ],
  }
];

export default NODE7;